import { AxiosInstancePlus } from '@tencent/oneid-request';
import type { IResponseType, IUserInfo } from 'common/constants/Types';
import { http } from 'common/http';
import captchaRequest from 'common/utils/captchaRequest';

class AuthnApi {
  public axiosInstance: AxiosInstancePlus = http;

  /**
   * 获取用户信息
   * @returns IUserInfo
   */
  getSelfV3(params?: { app?: string }): Promise<Required<IResponseType<IUserInfo>>> {
    return this.axiosInstance.get('/v1/authn:get_self_v3', { params, skipShowError: true });
  }

  /** 认证源登录, 获取state值 */
  getSSOLoginState(accountId: string, idpInstanceId: string): Promise<IResponseType> {
    return this.axiosInstance.get(`/v1/authn/sso/${accountId}/idp/${idpInstanceId}/applyLogin`);
  }

  changeEmailAccount(
    id: string,
    unionId: string,
  ): Promise<IResponseType<{ next: Record<string, any> }>> {
    return this.axiosInstance.post(`/v1/authn/emails/${id}:switch`, { unionId });
  }

  changeAccount(
    id: string,
    unionId: string,
    app?: string,
  ): Promise<IResponseType<{ next: Record<string, any> }>> {
    return captchaRequest((captchaVerification) =>
      this.axiosInstance.post(`/v1/authn/accounts/${id}:switch`, {
        id,
        unionId,
        captchaVerification,
        app,
      }),
    );
  }
}
export default new AuthnApi();
